import { render } from "./GroupEdit.vue?vue&type=template&id=1eddfc28&scoped=true"
import script from "./GroupEdit.vue?vue&type=script&lang=js"
export * from "./GroupEdit.vue?vue&type=script&lang=js"

import "./GroupEdit.vue?vue&type=style&index=0&id=1eddfc28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eddfc28"]])

export default __exports__